import React from 'react';
import './PhoneVueFeatures.css';
import featuresImage from '../../assets/images/features.png';

const PhoneVueFeatures = () => {
  return (
    <div className="phonevue-features-page">
      <div className="phonevue-features-container">
        <div className="features-content">
          <div className="phone-mockup-container">
            <img src={featuresImage} alt="PhoneVue Features - Battery Test" className="features-phone-image" />
          </div>

          <div className="features-text-content">
            <div className="features-header">
              <p className="features-label">Features</p>
              <h1 className="features-title">Diagnosis & Deterioration Prediction Diagnosis</h1>
            </div>

            <div className="feature-section">
              <h2 className="feature-section-title">Battery Deterioration Diagnosis</h2>
              <p className="feature-section-description">
                Diagnose the battery status from the current remaining battery level (*1). A graph is automatically created by repeating the diagnosis. (*2)
              </p>
              <div className="results-section">
                <p className="results-label">One of the following will be displayed as a result.</p>
                <ul className="results-list">
                  <li>Very good</li>
                  <li>Normal</li>
                  <li>Very bad</li>
                </ul>
              </div>
            </div>

            <div className="feature-section">
              <h2 className="feature-section-title">User Type Deterioration</h2>
              <p className="feature-section-description">
                By answering a few questions, you can diagnose the type of usage of your smartphone. The results of type diagnosis are also used to predict battery deterioration.
              </p>
              <div className="key-points">
                <p className="key-point">• It is necessary to have a type diagnosis at the time of the first diagnosis.</p>
                <p className="key-point">• Diagnostic results are predicted values.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PhoneVueFeatures;
